<template>
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="titulo" :subtitulo="P.Subtitulo?.Texto" :imagen="P.Imagen" :filtro="P.ImagenFiltro"
      :boton="P.ShowButton ? P.Button : null" />

    <section class="n2-seccion n2-seccion--pagina">
      <div class="n2-contenedor">
        <N2Buscador v-if="P.MostrarBuscador !== false && publicados.length" v-model="busqueda"
          :placeholder="tSolicitud('Buscar')" :sin-resultados="!servicios.length" />

        <!-- Panel: Servicios publicados y no ocultos en la sección, en el orden del panel -->
        <div class="n2-lista n2-lista--servicios" :class="{ 'n2-lista--una': columnas === 1 }" :style="{ '--n2-columnas': columnas }">
          <article v-for="s in servicios" :key="s.Slug" class="n2-ficha n2-aparece" :class="{ 'n2-ficha--sin-foto': !s.Imagen }">
            <img v-if="s.Imagen" class="n2-ficha__foto" :src="imagenIDtoSRC(s.Imagen)" :alt="s.Titulo" loading="lazy" />
            <span class="n2-ficha__num" aria-hidden="true">{{ String(publicados.indexOf(s) + 1).padStart(2, '0') }}</span>
            <div class="n2-ficha__cuerpo">
              <h2 class="n2-ficha__titulo"><NuxtLink :to="getLocalePath('/servicios/' + s.Slug)">{{ s.Titulo }}</NuxtLink></h2>
              <p v-if="resumen(s)">{{ resumen(s) }}</p>
              <div class="n2-ficha__acciones">
                <span class="n2-ficha__mas" aria-hidden="true">{{ tSolicitud('Más información') }} →</span>
                <NuxtLink v-if="acceso.visible('servicios') && acceso.tramiteDeServicio(s)" class="n2-boton n2-boton--acento"
                  :to="acceso.enlace('servicios', acceso.tramiteDeServicio(s))">{{ tSolicitud('Hacerlo online') }}</NuxtLink>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, columnasPanel, useAparicion } from '../../composables/useNotaria2'
import N2CabezaPagina from './N2CabezaPagina.vue'
import N2Buscador from './N2Buscador.vue'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()
const raiz = ref(null)
useAparicion(raiz)

// Panel: Diseño páginas → Servicios (título, subtítulo, imagen, buscador y columnas)
const P = computed(() => NOTARIA.value?.Theme?.Servicios ?? {})
const titulo = computed(() => P.value.Titulo?.Texto || tituloSeccion(NOTARIA.value, 'Servicios', $t))
const columnas = computed(() => columnasPanel(P.value.NumeroColumnas))

// Igual que la página de siempre: los publicados, salvo los marcados "solo en inicio"
const publicados = computed(() => (NOTARIA.value?.Servicios ?? []).filter(s => s.Publicado && s.MostrarEnSeccion !== false))
const busqueda = ref('')
const servicios = computed(() => {
  const q = busqueda.value.trim().toLowerCase()
  if (!q) return publicados.value
  return publicados.value.filter(s => [s.Titulo, s.Subtitulo, s.Extracto].some(t => String(t || '').toLowerCase().includes(q)))
})

const resumen = (s) => textoPlano(s.Extracto || s.Subtitulo || s.Contenido, 180)
</script>
